import { createFileRoute } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, TextKey } from '@mews-commander/enums';
import { MulticurrencySettings } from '@mews-commander/modules/src/modules/multicurrencySettings/';
import { PageLayout, QueryBoundary, useBreadcrumbs } from '@mews-commander/ui';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Settings/Multicurrency')({
    beforeLoad: ({ context: { checkPrivilege } }) => {
        checkPrivilege('configureEnterprise');
    },
    staticData: {
        owner: MewsTeam.Multicurrency,
        title: TextKey.MulticurrencySettingsPageTitle,
        type: RouteType.Frontend,
    },
    component: Layout,
});

const guideLink = createGuideLink(ArticlePath.MulticurrencyByMewsPaymentsFAQ);

function Layout() {
    const breadcrumbs = useBreadcrumbs();

    return (
        <PageLayout breadcrumbs={breadcrumbs} guideLink={guideLink}>
            <QueryBoundary loader="overlay">
                <MulticurrencySettings />
            </QueryBoundary>
        </PageLayout>
    );
}
